import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "flex p-0 m-0 justify-content-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "pt-0 mt-0" }, "Additional Information", -1)
const _hoisted_3 = { class: "grid p-0 m-0 pb-2" }
const _hoisted_4 = { class: "col-12 md:col-4 p-0 m-0 md:pr-1" }
const _hoisted_5 = { class: "grid p-1 m-0 pr-2 col-12" }
const _hoisted_6 = { class: "p-inputgroup" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("small", { class: "p-inputgroup-addon font-semibold general-label-color medium-addon" }, "Name *", -1)
const _hoisted_8 = { class: "col-12 md:col-8 p-0 m-0 md:pl-1 md:pr-1" }
const _hoisted_9 = { class: "grid p-1 m-0 md:pl-2 pr-2 col-12 xl:col-6" }
const _hoisted_10 = { class: "p-inputgroup" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("small", { class: "p-inputgroup-addon font-semibold general-label-color medium-addon" }, "Description", -1)
const _hoisted_12 = { class: "col-12 md:col-4 p-0 m-0 lg:mt-2 md:pr-1" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "grid p-1 m-0 pr-2 col-12" }, [
  /*#__PURE__*/_createElementVNode("small", { class: "bold-label" }, "My information")
], -1)
const _hoisted_14 = { class: "grid p-1 m-0 pr-2 col-12" }
const _hoisted_15 = { class: "col-12 p-0 field" }
const _hoisted_16 = { class: "grid col-12 md:col-8 p-0 m-0 lg:mt-2 md:pl-1 md:pr-1 align-content-start" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "grid p-1 m-0 md:pl-2 pr-2 col-12" }, [
  /*#__PURE__*/_createElementVNode("small", { class: "bold-label" }, "Customer information")
], -1)
const _hoisted_18 = { class: "grid p-1 m-0 md:pl-2 pr-2 col-12 md:col-6" }
const _hoisted_19 = { class: "p-inputgroup" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("small", { class: "p-inputgroup-addon font-semibold general-label-color medium-addon" }, "First Name", -1)
const _hoisted_21 = { class: "grid p-1 m-0 md:pl-2 pr-2 col-12 md:col-6" }
const _hoisted_22 = { class: "p-inputgroup" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("small", { class: "p-inputgroup-addon font-semibold general-label-color medium-addon" }, "Last Name", -1)
const _hoisted_24 = { class: "grid p-1 m-0 md:pl-2 pr-2 col-12 md:col-6" }
const _hoisted_25 = { class: "p-inputgroup" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("small", { class: "p-inputgroup-addon font-semibold general-label-color medium-addon" }, "Company", -1)
const _hoisted_27 = { class: "grid p-1 m-0 md:pl-2 pr-2 col-12 md:col-6" }
const _hoisted_28 = { class: "p-inputgroup" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("small", { class: "p-inputgroup-addon font-semibold general-label-color medium-addon" }, "Email", -1)
const _hoisted_30 = { class: "grid p-1 m-0 md:pl-2 pr-2 col-12 md:col-6" }
const _hoisted_31 = { class: "p-inputgroup" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("small", { class: "p-inputgroup-addon font-semibold general-label-color medium-addon" }, "Phone", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "hidden md:inline-flex grid p-1 m-0 md:pl-2 pr-2 col-12 md:col-6" }, null, -1)
const _hoisted_34 = { class: "p-inputgroup" }
const _hoisted_35 = { class: "p-inputgroup-addon font-semibold general-label-color medium-addon" }
const _hoisted_36 = { class: "grid p-1 m-0 md:pl-2 pr-2 col-12 md:col-6" }
const _hoisted_37 = { class: "p-inputgroup" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("small", { class: "p-inputgroup-addon font-semibold general-label-color medium-addon" }, "Zip", -1)
const _hoisted_39 = { class: "grid p-1 m-0 md:pl-2 pr-2 col-12 md:col-6" }
const _hoisted_40 = { class: "p-inputgroup" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("small", { class: "p-inputgroup-addon font-semibold general-label-color medium-addon" }, "City", -1)
const _hoisted_42 = { class: "grid p-1 m-0 md:pl-2 pr-2 col-12 md:col-6" }
const _hoisted_43 = { class: "p-inputgroup" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("small", { class: "p-inputgroup-addon font-semibold general-label-color medium-addon" }, "State", -1)
const _hoisted_45 = { class: "grid p-1 m-0 md:pl-2 pr-2 col-12 md:col-6" }
const _hoisted_46 = { class: "p-inputgroup" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("small", { class: "p-inputgroup-addon font-semibold general-label-color medium-addon" }, "Country", -1)
const _hoisted_48 = { class: "p-0 m-0" }
const _hoisted_49 = { class: "p-column-title block" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = { class: "p-0 m-0" }
const _hoisted_52 = { class: "flex p-0 m-0 justify-content-around" }
const _hoisted_53 = { class: "flex align-items-center" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "hidden lg:flex w-1" }, null, -1)
const _hoisted_55 = { class: "p-0 m-0" }
const _hoisted_56 = { class: "p-0 m-0" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", { class: "p-column-title sell-adj-title" }, "Sell Price Adjustment", -1)
const _hoisted_58 = { class: "flex p-0 m-0" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-question-circle pl-2 pt-1",
  style: {"font-size":"1rem","color":"black"}
}, null, -1)
const _hoisted_60 = { class: "p-0 m-0" }
const _hoisted_61 = { class: "flex p-0 m-0 justify-content-around" }
const _hoisted_62 = { class: "flex align-item-baseline" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "hidden lg:flex w-1" }, null, -1)
const _hoisted_64 = { class: "p-0 m-0" }
const _hoisted_65 = { class: "flex p-0 m-0 justify-content-around" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "hidden lg:flex w-1" }, null, -1)
const _hoisted_67 = { class: "p-0 m-0" }
const _hoisted_68 = { class: "grid pt-3 col-12 justify-content-end" }
const _hoisted_69 = { class: "grid p-1 m-0 pr-3 col-12 pt-0 align-items-baseline justify-content-end" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("span", { class: "col-6 md:col-3 p-0 font-bold justify-content-end text-right" }, " My Total Cost: ", -1)
const _hoisted_71 = { class: "col-6 md:col-2 p-0 xl:col-1 font-medium justify-content-end text-right" }
const _hoisted_72 = { class: "grid p-1 m-0 pr-3 col-12 pt-0 align-items-baseline justify-content-end" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("span", { class: "col-6 md:col-3 p-0 font-bold justify-content-end text-right" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-question-circle pr-1 pt-1",
    style: {"font-size":"1rem","color":"black"}
  }),
  /*#__PURE__*/_createTextVNode(" Total Sell Price: ")
], -1)
const _hoisted_74 = { class: "col-6 md:col-2 xl:col-1 p-0 font-medium justify-content-end text-right" }
const _hoisted_75 = { class: "grid p-1 m-0 pr-3 col-12 pt-0 align-items-baseline justify-content-end" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("span", { class: "col-6 md:col-3 font-bold p-0 justify-content-end text-right" }, " Profit / Loss: ", -1)
const _hoisted_77 = { class: "grid p-0 m-0 align-items-start" }
const _hoisted_78 = { class: "grid col-12 md:col-12 p-0 m-0" }
const _hoisted_79 = { class: "col-12 p-1 pr-2 m-0" }
const _hoisted_80 = { class: "grid p-1 m-0 pr-2 col-7 service-name" }
const _hoisted_81 = { class: "p-inputgroup" }
const _hoisted_82 = { key: 0 }
const _hoisted_83 = { key: 1 }
const _hoisted_84 = { class: "grid p-1 m-0 pr-2 col-5 justify-content-end service-charge" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("small", { class: "font-bold pt-2" }, "$", -1)
const _hoisted_86 = { class: "p-inputgroup align-items-center col-5 md:col-3 mt-0 pt-0" }
const _hoisted_87 = ["onClick"]
const _hoisted_88 = { class: "grid p-1 m-0 pr-2 col-7 service-description" }
const _hoisted_89 = { class: "col-12 p-0 field" }
const _hoisted_90 = { class: "grid col-12 md:col-12 p-0 m-0 align-items-start justify-content-end" }
const _hoisted_91 = { class: "grid p-1 m-0 pr-3 col-12 align-items-center justify-content-end" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("small", { class: "col-6 md:col-4 font-bold justify-content-end text-right" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "pi pi-question-circle pr-1 pt-1",
    style: {"font-size":"1rem","color":"black"}
  }),
  /*#__PURE__*/_createTextVNode(" Quoted Total Price: ")
], -1)
const _hoisted_93 = { class: "grid p-1 m-0 pr-2 align-items-center justify-content-end" }
const _hoisted_94 = { class: "col-6 md:col-2 xl:col-1 p-0 m-0 pl-1 pr-1 h-2rem" }
const _hoisted_95 = {
  key: 0,
  class: "col-6 md:col-3 lg:col-2 p-0 m-0 pl-1 pr-1 h-2rem",
  style: {"max-width":"fit-content","min-width":"fit-content"}
}
const _hoisted_96 = { class: "col-6 md:col-2 xl:col-1 p-0 m-0 pl-1 pr-1 h-2rem" }
const _hoisted_97 = { class: "p-fluid" }
const _hoisted_98 = {
  key: 0,
  class: "p-inputgroup mt-2"
}
const _hoisted_99 = /*#__PURE__*/_createElementVNode("small", { class: "p-inputgroup-addon font-semibold general-label-color" }, "Email", -1)
const _hoisted_100 = { key: 1 }
const _hoisted_101 = { class: "p-error p-0 m-0 pl-2" }
const _hoisted_102 = { class: "field-checkbox align-items-start mt-3 mb-2 pl-2" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("label", { for: "show-model-number" }, "Show Model Number", -1)
const _hoisted_104 = { class: "field-checkbox align-items-start ml-2" }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("label", { for: "show-prices" }, "Show Prices", -1)
const _hoisted_106 = { class: "flex justify-content-end p-0 m-0" }
const _hoisted_107 = { class: "p-0 m-0" }
const _hoisted_108 = { class: "p-0 m-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NotificationCard = _resolveComponent("NotificationCard")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_TextArea = _resolveComponent("TextArea")!
  const _component_InputMask = _resolveComponent("InputMask")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_CollapsibleSection = _resolveComponent("CollapsibleSection")!
  const _component_Column = _resolveComponent("Column")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_SplitButton = _resolveComponent("SplitButton")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NotificationCard),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Card, { class: "edit-quote-card p-0 mt-3" }, {
        content: _withCtx(() => [
          _createElementVNode("h3", null, "Quote # " + _toDisplayString(this.quoteInfo.id), 1),
          _hoisted_2,
          _createVNode(_component_CollapsibleSection, {
            isOpen: _ctx.sections.customerInformation,
            header: "Information",
            "onUpdate:isOpen": _cache[13] || (_cache[13] = ($event: any) => (_ctx.toggleSectionIcon('customerInformation')))
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _hoisted_7,
                      _createVNode(_component_InputText, {
                        type: "text",
                        class: "text-sm w-full",
                        modelValue: _ctx.quoteInfo.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.quoteInfo.name) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createVNode(_component_InputText, {
                        type: "text",
                        class: "text-sm w-full",
                        modelValue: _ctx.quoteInfo.description,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.quoteInfo.description) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_TextArea, {
                        id: "my-info",
                        placeholder: "Insert information here...",
                        class: "text-sm w-full",
                        modelValue: _ctx.quoteInfo.myInfo,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.quoteInfo.myInfo) = $event)),
                        cols: "30",
                        rows: "5"
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _createVNode(_component_InputText, {
                        type: "text",
                        class: "text-sm w-full",
                        modelValue: _ctx.quoteInfo.customerInfo.firstName,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.quoteInfo.customerInfo.firstName) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _createVNode(_component_InputText, {
                        type: "text",
                        class: "text-sm w-full",
                        modelValue: _ctx.quoteInfo.customerInfo.lastName,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.quoteInfo.customerInfo.lastName) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _hoisted_26,
                      _createVNode(_component_InputText, {
                        type: "text",
                        class: "text-sm w-full",
                        modelValue: _ctx.quoteInfo.customerInfo.company,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.quoteInfo.customerInfo.company) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _createVNode(_component_InputText, {
                        type: "text",
                        class: "text-sm w-full",
                        modelValue: _ctx.quoteInfo.customerInfo.email,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.quoteInfo.customerInfo.email) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _hoisted_32,
                      _createVNode(_component_InputMask, {
                        mask: "999-999-9999",
                        placeholder: "999-999-9999",
                        class: "text-sm w-full",
                        modelValue: _ctx.quoteInfo.customerInfo.phone,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.quoteInfo.customerInfo.phone) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _hoisted_33,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quoteInfo.customerInfo.addresses, (address, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "grid p-1 m-0 md:pl-2 pr-2 col-12 md:col-6"
                    }, [
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("small", _hoisted_35, "Street - " + _toDisplayString(index), 1),
                        _createVNode(_component_InputText, {
                          type: "text",
                          class: "text-sm w-full",
                          modelValue: _ctx.quoteInfo.customerInfo.addresses[index].address,
                          "onUpdate:modelValue": ($event: any) => ((_ctx.quoteInfo.customerInfo.addresses[index].address) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        _createVNode(_component_Button, {
                          title: "Add Address Line",
                          icon: "pi pi-plus",
                          class: "text-sm font-bold pl-2 pr-2",
                          onClick: ($event: any) => (_ctx.addAddressLine(index))
                        }, null, 8, ["onClick"]),
                        (index > 0)
                          ? (_openBlock(), _createBlock(_component_Button, {
                              key: 0,
                              icon: "pi pi-trash",
                              title: "Remove Address Line",
                              class: "text-sm font-bold pl-2 pr-2",
                              onClick: ($event: any) => (_ctx.deleteAddressLine(index))
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _hoisted_38,
                      _createVNode(_component_InputText, {
                        type: "text",
                        class: "text-sm w-full",
                        modelValue: _ctx.quoteInfo.customerInfo.zip,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.quoteInfo.customerInfo.zip) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _hoisted_41,
                      _createVNode(_component_InputText, {
                        type: "text",
                        class: "text-sm w-full",
                        modelValue: _ctx.quoteInfo.customerInfo.city,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.quoteInfo.customerInfo.city) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _hoisted_44,
                      _createVNode(_component_InputText, {
                        type: "text",
                        class: "text-sm w-full",
                        modelValue: _ctx.quoteInfo.customerInfo.state,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.quoteInfo.customerInfo.state) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _hoisted_47,
                      _createVNode(_component_Dropdown, {
                        type: "text",
                        modelValue: _ctx.quoteInfo.customerInfo.country,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.quoteInfo.customerInfo.country) = $event)),
                        options: _ctx.getCountries(),
                        onSelect: _cache[12] || (_cache[12] = ($event: any) => (_ctx.getCountryCode(''))),
                        class: "text-sm w-full"
                      }, null, 8, ["modelValue", "options"])
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["isOpen"]),
          _createVNode(_component_CollapsibleSection, {
            isOpen: _ctx.sections.parts,
            header: "Parts Information",
            "onUpdate:isOpen": _cache[17] || (_cache[17] = ($event: any) => (_ctx.toggleSectionIcon('parts')))
          }, {
            content: _withCtx(() => [
              _createVNode(_component_DataTable, {
                value: _ctx.quoteInfo.parts,
                paginator: false,
                breakpoint: "1023px",
                removableSort: "",
                class: "p-datatable-sm mb-4 mt-2 edit-quote-datatable"
              }, {
                empty: _withCtx(() => [
                  _createTextVNode(" No Parts to display. ")
                ]),
                footer: _withCtx(() => [
                  _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("div", _hoisted_69, [
                      _hoisted_70,
                      _createElementVNode("span", _hoisted_71, " $" + _toDisplayString(this.totalCost), 1)
                    ]),
                    _createElementVNode("div", _hoisted_72, [
                      _hoisted_73,
                      _createElementVNode("span", _hoisted_74, " $" + _toDisplayString(this.totalPrice), 1)
                    ]),
                    _createElementVNode("div", _hoisted_75, [
                      _hoisted_76,
                      _createElementVNode("span", {
                        class: _normalizeClass(`${(this.totalPrice - this.totalCost) < 0 ? 'lost' : 'profit'} col-6 md:col-2 xl:col-1 p-0 font-bold justify-content-end text-right`)
                      }, _toDisplayString(this.profitSign) + " $" + _toDisplayString(Math.abs((this.totalPrice - this.totalCost).toFixed(2))), 3)
                    ])
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    field: "partNumber",
                    header: "ID",
                    class: "text-sm text-left",
                    sortable: true
                  }, {
                    body: _withCtx(({data, index}) => [
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("span", _hoisted_49, [
                          _createElementVNode("i", {
                            class: "pi pi-trash pr-2 xl:pr-3",
                            style: {"font-size":"1rem","color":"red"},
                            onClick: ($event: any) => (_ctx.isPartsTableEditable && _ctx.handleRemovePart(index))
                          }, null, 8, _hoisted_50),
                          _createTextVNode(" " + _toDisplayString(data.partalt || data.partNumber), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "qty",
                    header: "Quantity",
                    class: "text-sm text-center",
                    sortable: true
                  }, {
                    body: _withCtx(({data}) => [
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("div", _hoisted_53, [
                            _createVNode(_component_InputNumber, {
                              id: "sell-price-adjustment",
                              modelValue: data.qty,
                              "onUpdate:modelValue": ($event: any) => ((data.qty) = $event),
                              class: "text-sm sell-price-adjustment-qty pr-1",
                              disabled: !_ctx.isPartsTableEditable
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
                            _createTextVNode(" E ")
                          ]),
                          _hoisted_54
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "currentCost",
                    header: "Current Cost",
                    class: "text-sm text-center",
                    sortable: true
                  }, {
                    body: _withCtx(({ data }) => [
                      _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.formatPrice(data.currentCost)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "sellPriceAdjustment",
                    class: "text-sm text-center",
                    sortable: true
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_56, [
                        _hoisted_57,
                        _createElementVNode("div", _hoisted_58, [
                          _createVNode(_component_InputNumber, {
                            id: "sell-price-adjustment",
                            modelValue: _ctx.sellPriceAdjustment.qty,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.sellPriceAdjustment.qty) = $event)),
                            minFractionDigits: 1,
                            class: "text-sm sell-price-adjustment-qty",
                            placeholder: "0.0",
                            disabled: !_ctx.isPartsTableEditable
                          }, null, 8, ["modelValue", "disabled"]),
                          _createVNode(_component_Dropdown, {
                            type: "text",
                            modelValue: _ctx.sellPriceAdjustment.measurement,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.sellPriceAdjustment.measurement) = $event)),
                            options: ['$', '%'],
                            class: "text-sm w-full sell-price-adjustment-measurement",
                            disabled: !_ctx.isPartsTableEditable
                          }, null, 8, ["modelValue", "disabled"])
                        ]),
                        _createElementVNode("span", {
                          class: "p-column-title link-style block",
                          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.handleSellPriceAdjustmentApplyToAll($event)))
                        }, [
                          _createTextVNode("Apply to All "),
                          _hoisted_59
                        ])
                      ])
                    ]),
                    body: _withCtx(({data, index}) => [
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, [
                          _createElementVNode("div", _hoisted_62, [
                            _createVNode(_component_InputNumber, {
                              id: "sell-price-adjustment",
                              modelValue: data.sellPriceAdjustment.qty,
                              "onUpdate:modelValue": ($event: any) => ((data.sellPriceAdjustment.qty) = $event),
                              minFractionDigits: 1,
                              class: "text-sm sell-price-adjustment-qty",
                              disabled: !_ctx.isPartsTableEditable,
                              onInput: ($event: any) => (_ctx.onInputQty(index, $event)),
                              placeholder: "0.0"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onInput"]),
                            _createVNode(_component_Dropdown, {
                              type: "text",
                              modelValue: data.sellPriceAdjustment.measurement,
                              "onUpdate:modelValue": ($event: any) => ((data.sellPriceAdjustment.measurement) = $event),
                              options: ['$', '%'],
                              class: "text-sm w-full sell-price-adjustment-measurement",
                              disabled: !_ctx.isPartsTableEditable,
                              onChange: ($event: any) => (_ctx.onInputMeasurement(index, $event))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"])
                          ]),
                          _hoisted_63
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "customerSellPrice",
                    header: "Customer Sell Price",
                    class: "text-sm text-center",
                    sortable: true
                  }, {
                    body: _withCtx(({data, index}) => [
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("div", _hoisted_65, [
                          _createElementVNode("div", null, [
                            _createTextVNode("$ "),
                            _createVNode(_component_InputNumber, {
                              id: "sell-price-adjustment",
                              modelValue: data.customerSellPrice,
                              "onUpdate:modelValue": ($event: any) => ((data.customerSellPrice) = $event),
                              minFractionDigits: 2,
                              maxFractionDigits: 2,
                              class: "text-sm sell-price-adjustment-qty",
                              disabled: !_ctx.isPartsTableEditable,
                              onInput: ($event: any) => (_ctx.onInputSellPrice(index, $event))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onInput"])
                          ]),
                          _hoisted_66
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "extendedSellPrice",
                    header: "Extended Sell Price",
                    class: "text-sm text-center",
                    sortable: true,
                    style: {"width":"10rem"}
                  }, {
                    body: _withCtx(({ data }) => [
                      _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.formatPrice(data.customerSellPrice * data.qty)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            _: 1
          }, 8, ["isOpen"]),
          _createVNode(_component_CollapsibleSection, {
            isOpen: _ctx.sections.goodsAndServices,
            header: "Additional Goods and Service",
            "onUpdate:isOpen": _cache[21] || (_cache[21] = ($event: any) => (_ctx.toggleSectionIcon('goodsAndServices')))
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_77, [
                _createElementVNode("div", _hoisted_78, [
                  _createElementVNode("div", _hoisted_79, [
                    _createVNode(_component_Button, {
                      label: "Add a good or service",
                      icon: "pi pi-plus",
                      class: "text-sm font-bold pl-2 pr-2",
                      onClick: this.addService
                    }, null, 8, ["onClick"])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quoteInfo.goodOrService, (service, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "grid col-12 md:col-12 p-0 m-0 service-section"
                    }, [
                      _createElementVNode("div", _hoisted_80, [
                        _createElementVNode("div", _hoisted_81, [
                          _createVNode(_component_Dropdown, {
                            modelValue: service.name,
                            "onUpdate:modelValue": ($event: any) => ((service.name) = $event),
                            class: "text-sm w-full",
                            placeholder: "Select a good or service",
                            panelClass: "goods-dropdown",
                            options: ['Labor', 'Extended Labor Warranty', 'Misc Material', 'Other']
                          }, {
                            value: _withCtx((slotProps) => [
                              (slotProps.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                    _createTextVNode(_toDisplayString(slotProps.value) + " ", 1),
                                    (slotProps.value === 'Other')
                                      ? (_openBlock(), _createBlock(_component_InputText, {
                                          key: 0,
                                          modelValue: _ctx.tempService,
                                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.tempService) = $event)),
                                          placeholder: "Specify other service",
                                          class: "w-11 m-0 text-sm",
                                          onBlur: () => {service.name = _ctx.tempService; _ctx.tempService = ''},
                                          onKeydownCapture: ($event: any) => (_ctx.onServiceDropdownKeydown(index, $event)),
                                          onKeydown: _cache[19] || (_cache[19] = _withKeys(_withModifiers(() => {}, ["stop"]), ["space"])),
                                          onKeyup: _cache[20] || (_cache[20] = _withKeys(_withModifiers(() => {}, ["stop"]), ["space"]))
                                        }, null, 8, ["modelValue", "onBlur", "onKeydownCapture"]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_83, _toDisplayString(slotProps.placeholder), 1))
                            ]),
                            _: 2
                          }, 1032, ["modelValue", "onUpdate:modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_84, [
                        _hoisted_85,
                        _createElementVNode("div", _hoisted_86, [
                          _createVNode(_component_InputNumber, {
                            minFractionDigits: 2,
                            maxFractionDigits: 2,
                            class: "text-sm sell-price-adjustment-qty",
                            disabled: !_ctx.isPartsTableEditable,
                            modelValue: service.charge,
                            "onUpdate:modelValue": ($event: any) => ((service.charge) = $event)
                          }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"]),
                          _createElementVNode("i", {
                            class: "pi pi-trash pr-2 xl:pr-3",
                            style: {"font-size":"1rem","color":"red","margin-left":"1rem"},
                            onClick: ($event: any) => (_ctx.deleteGoodOrService(index))
                          }, null, 8, _hoisted_87)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_88, [
                        _createElementVNode("div", _hoisted_89, [
                          _createVNode(_component_TextArea, {
                            id: "new-good-or-service-notes",
                            placeholder: "Optional Notes",
                            class: "text-sm w-full",
                            modelValue: service.notes,
                            "onUpdate:modelValue": ($event: any) => ((service.notes) = $event),
                            cols: "30",
                            rows: "2"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ])
                      ])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_90, [
                  _createElementVNode("div", _hoisted_91, [
                    _hoisted_92,
                    _createElementVNode("small", {
                      class: _normalizeClass(`${ _ctx.totalQuotedPrice < 0 ? 'lost' : 'profit'} total-quote-color col-6 md:col-3 font-bold justify-content-end text-right`)
                    }, _toDisplayString(this.sign) + " $" + _toDisplayString(Math.abs((this.totalQuotedPrice).toFixed(2))), 3)
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["isOpen"]),
          _createElementVNode("div", _hoisted_93, [
            _createElementVNode("div", _hoisted_94, [
              _createVNode(_component_Button, {
                label: "Cancel",
                class: "text-sm font-bold pl-2 pr-2 col-12",
                onClick: _ctx.onCancel
              }, null, 8, ["onClick"])
            ]),
            (!this.getQuoteToEdit && this.currentOrder.length !== 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                  _createVNode(_component_Button, {
                    label: "Return to Cart",
                    class: "text-sm font-bold pl-2 pr-2 col-12",
                    onClick: _cache[22] || (_cache[22] = () => _ctx.$router.push('/sales'))
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_96, [
              _createVNode(_component_SplitButton, {
                label: "Save",
                icon: "pi pi-save",
                class: "edit-quote-save-btn",
                onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.save())),
                model: _ctx.saveItems
              }, null, 8, ["model"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_Dialog, {
      header: _ctx.getModalTitle,
      visible: _ctx.showSaveModal,
      modal: true,
      closable: false,
      class: "w-11 md:w-6 lg:w-4 xl:w-3"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_106, [
          _createElementVNode("div", _hoisted_107, [
            _createVNode(_component_Button, {
              label: "Cancel",
              icon: "pi pi-times",
              class: "p-button-text",
              onClick: _ctx.handleCloseModal
            }, null, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_108, [
            _createVNode(_component_Button, {
              label: _ctx.getModalButtonLabel,
              icon: _ctx.isLoading ? 'pi pi-spin pi-spinner' : 'pi pi-check',
              disabled: ((!_ctx.email || _ctx.v$.email.$invalid) && _ctx.showEmailDialog) || _ctx.isLoading,
              onClick: _ctx.handleShareOrDownload
            }, null, 8, ["label", "icon", "disabled", "onClick"])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_97, [
          (_ctx.showEmailDialog)
            ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                _hoisted_99,
                _createVNode(_component_InputText, {
                  modelValue: _ctx.email,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.email) = $event)),
                  class: _normalizeClass({ 'text-sm p-invalid': _ctx.v$.email.email.$invalid}),
                  placeholder: "Enter your email...",
                  type: "email"
                }, null, 8, ["modelValue", "class"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.showEmailDialog && _ctx.v$.email.email.$invalid)
            ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                _createElementVNode("small", _hoisted_101, _toDisplayString(_ctx.v$.email.email.$message), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_102, [
            _createVNode(_component_Checkbox, {
              id: "show-model-number",
              modelValue: _ctx.showModelNumber,
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.showModelNumber) = $event)),
              binary: true
            }, null, 8, ["modelValue"]),
            _hoisted_103
          ]),
          _createElementVNode("div", _hoisted_104, [
            _createVNode(_component_Checkbox, {
              id: "show-prices",
              modelValue: _ctx.showPrices,
              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.showPrices) = $event)),
              binary: true
            }, null, 8, ["modelValue"]),
            _hoisted_105
          ])
        ])
      ]),
      _: 1
    }, 8, ["header", "visible"]),
    _createVNode(_component_ConfirmDialog)
  ], 64))
}